var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-timeline-wrapper" },
    _vm._l(_vm.getGroupedByDate, function(item, index) {
      return _c(
        "div",
        { attrs: { index: index } },
        [
          _vm.showStartNode(item[1])
            ? _c("div", { staticClass: "node-date-wrapper" }, [
                _vm._m(0, true),
                _vm._v(" "),
                _c("div", { staticClass: "date-styling" }, [
                  _vm._v(_vm._s(_vm.getYear(item[0])))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.filteredGroupedByDate(item[1]), function(entity, i) {
            return _c("div", { key: i }, [
              _vm.getCardTitle(entity)
                ? _c(
                    "div",
                    [
                      _c("entity-card", {
                        staticStyle: { margin: "0 !important" },
                        attrs: {
                          cardTitle: _vm.getCardTitle(entity),
                          date: _vm.formatDate(entity.eventDate)
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("onEntityCardClick", entity)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.showLink(i, _vm.filteredGroupedByDate(item[1]))
                        ? _c("div", { staticClass: "card-link" })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ])
          })
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "node-to-link" }, [
      _c("div", { staticClass: "timeline-node" }),
      _vm._v(" "),
      _c("div", { staticClass: "timeline-link" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }